import { CldSourceMediaSize } from './../../../shared/components/cld-picture/cld-picture.interface';
import { CardBlockComponent } from './../../../shared/components/card-block/card-block.component';
import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy, Inject, ViewChild, Optional } from '@angular/core';
import { IProduct } from '@collections/products/interfaces';
import { NgTemplateOutlet } from '@angular/common';
import { ProductStatus } from '@collections/products/enums/products.enums';
import { AnalyticsService } from 'app/shared/services/google-tag-manager/analytics/analytics.service';
import { LoadingCardBlockComponent } from '../../../shared/components/loading-card-block/loading-card-block.component';
import { OnScrollViewDirective } from '../../../shared/scroll/on-scroll-view.directive';
import { CardBlockComponent as CardBlockComponent_1 } from '../../../shared/components/card-block/card-block.component';
import { ExpoButtonComponent } from 'app/shared/components/expo-button/expo-button.component';
import { UsersService } from 'app/shared/services/users/users.service';

@Component({
    selector: 'product-block',
    templateUrl: './product-block.component.html',
    styleUrls: ['./product-block.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CardBlockComponent_1, OnScrollViewDirective, LoadingCardBlockComponent, NgTemplateOutlet, ExpoButtonComponent]
})
export class ProductBlockComponent implements OnInit {

  @Input() productItem: IProduct;
  @Input() index: number;
  @Input() urlPrefix = './';
  @Input() imageSizes: CldSourceMediaSize[];
  @Input() itemListId: string;
  @Input() itemListName: string;

  productFallbackImage: string;
  productStatusEnum = ProductStatus;
  get hovered(): boolean {
    return this.cardBlock?.hovered;
  }

  @ViewChild(CardBlockComponent, {static: false}) cardBlock: CardBlockComponent;

  constructor(
    @Inject('FALLBACK_PRODUCT_IMAGE') _productFallbackImage,
    @Optional() private analyticsService: AnalyticsService,
    private usersService: UsersService
    ) {
      this.productFallbackImage = _productFallbackImage;
    }

  ngOnInit(): void {
  }

  trackViewListItem(isVisible: boolean): void {
    if (isVisible) {
      this.analyticsService.ecTracKViewItemList(this.productItem, this.itemListId, this.itemListName);
    }
  }

  trackItemSelected(): void {
    this.analyticsService.ecTrackSelectItem(this.productItem, this.itemListId, this.itemListName);
  }

  toggleSaveProduct( action: 'save' | 'remove' ) {
    this.usersService.toggleSaveProduct(this.productItem, action);
  }

  isSavedProduct( ) {
    return (this.usersService.isSavedProduct(this.productItem._id));
  }


}
